import React from 'react';
import emailjs from 'emailjs-com';
import './ContactUs.css';
import {Container, Row, Col} from 'react-bootstrap';

export default function ContactUs() {

  function sendEmail(e) {
    e.preventDefault();
    

    emailjs.sendForm('service_x7kum49', 'template_quvwx1s', e.target, 'user_rHKPabhiiu9p1TAccX8UK')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset();
  }

  return (
    <Container fluid>
      <Row>
        <Col md={12} xs={4}>
    <form onSubmit={sendEmail}>
      <div class="pageTitle title">Contact Us </div>
      <div>Lusaka HQ, Plot No.20995,Kafue Road Opposite. Castle shopping centre.
+260 211 845 793 | 

Lusaka Chandwe Musonda Rd, Light Industrial Area - Next to Espeka
+260 97 7 845 459 | 

Freetown Road, Kitwe - Zambia
+260 21 2 223 192 | 

Ndola Plot No.1256A, President Avenue
+260 21 2 622 207 | 

DRC, Shop No.15, Marwa Building, Av. Moero 2266 Bld M'siri
+243 990 536 976 | 

Umodzi Highway, Chipata - Zambia
+260 96 6 855 379</div>
      <div class="secondaryTitle title">Or Please fill this form to contact us and Click on Send.</div>
      
      <label className="secondaryTitle title">Type Your Name</label>
      <input type="text" name="user_name" className="email formEntry" placeholder="Name"/>
      <label className="secondaryTitle title">Your Email Address</label>
      <input type="email" name="user_email" className="email formEntry" placeholder="Email"/>
      <label className="secondaryTitle title">Contact Number</label>
      <input type="text" name="contact_number" className="email formEntry" placeholder="Contact Number"/>
      <label className="secondaryTitle title">Type your Message</label>
      <textarea name="message" className="message formEntry" placeholder="Message"></textarea>
      <input type="submit" value="Send" className="submit formEntry"/>
    </form>
       </Col>
    </Row>
      
  </Container>
  );
};